import hamburger from './components/hamburger'
import slider from './components/slider'

import skrollTo from './lib/skrollto';

document.addEventListener("DOMContentLoaded", () => {
    document.querySelector('.offscreen-nav').removeAttribute('style');
    hamburger();
    slider();

    document.querySelector('.to-top-arrow').addEventListener('click', (e) => {
        e.preventDefault();
        const scrollDuration = Math.min(1200, window.scrollY*1.05);
        skrollTo.scrollTo({
            to: 0,
            duration: scrollDuration
        });
    });
});

